import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { formatFarmDate, formatFarmTime } from '../utils/farmDateTime';

export function useFarmDateTime() {
  const { state } = useContext(AuthContext);
  const tz = state.farmTimeZoneId;
  const locale = state.culture;

  return {
    formatDate: (dateStr: string) => formatFarmDate(dateStr, tz, locale),
    formatTime: (dateStr: string) => formatFarmTime(dateStr, tz, locale),
    timeZoneId: tz
  };
}
